import { render, staticRenderFns } from "./TheUpperRightCornerBanner.vue?vue&type=template&id=66a5837f&scoped=true"
import script from "./TheUpperRightCornerBanner.vue?vue&type=script&lang=ts"
export * from "./TheUpperRightCornerBanner.vue?vue&type=script&lang=ts"
import style0 from "./TheUpperRightCornerBanner.vue?vue&type=style&index=0&id=66a5837f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5837f",
  null
  
)

export default component.exports